export default __webpack_public_path__ + "media/images/tenant/hero_2-8ae944394b18bbf94348283fe2d19c6d.webp";